<div class="mat-dialog-wrapper">
  <div class="d-flex justify-space-between align-items-center mb-1">
    <h2 mat-dialog-title class="m-0">Add New Audit</h2>
    <button
          mat-button
          class="header-text-close d-flex align-items-center"
          disableRipple
          mat-dialog-close
    >
    <mat-icon>close</mat-icon>
    </button>
    </div>
    <mat-dialog-content>
      <form [formGroup]="contactDetailForm">
        <div class="sidenav-body">
          <div class="d-flex gap-20">
            <div class="form-field">
              <p class="fw-bold">Name <span class="text-red">*</span></p>
              <mat-form-field appearance="fill" class="w-230">
                <input
                  type="text"
                  matInput
                  maxlength="255"
                  autocomplete="off"
                  formControlName="name"
                />
              </mat-form-field>
            </div>
            <div class="form-field">
              <p class="fw-bold">Last Name <span class="text-red">*</span></p>
              <mat-form-field appearance="fill" class="w-230">
                <input
                  matInput
                  formControlName="lastName"
                  autocomplete="off"
                  maxlength="320"
                />
              </mat-form-field>
            </div>
          </div>

          <div class="d-flex gap-20">
            <div class="form-field">
              <p class="fw-bold">Address 1</p>
              <mat-form-field appearance="fill" class="w-230">
                <input
                  type="text"
                  matInput
                  maxlength="255"
                  autocomplete="off"
                  formControlName="address1"
                />
              </mat-form-field>
            </div>
            <div class="form-field">
              <p class="fw-bold">Address 2</p>
              <mat-form-field appearance="fill" class="w-230">
                <input
                  matInput
                  formControlName="address2"
                  autocomplete="off"
                  maxlength="320"
                />
              </mat-form-field>
            </div>
          </div>

          <div class="d-flex gap-20">
            <div class="form-field">
              <p class="fw-bold">City</p>
              <mat-form-field appearance="fill" class="w-230">
                <input
                  type="text"
                  matInput
                  maxlength="255"
                  autocomplete="off"
                  formControlName="city"
                />
              </mat-form-field>
            </div>
            <div class="form-field">
                <p class="fw-bold">Post Code</p>
                <mat-form-field appearance="fill" class="w-230">
                  <input
                    type="text"
                    matInput
                    maxlength="255"
                    autocomplete="off"

                    formControlName="postCode"
                  />
                </mat-form-field>
              </div>
          </div>
          
          <div class="d-flex gap-20">
            <div class="form-field">
              <p class="fw-bold">County</p>
              <mat-form-field appearance="fill" class="w-230">
                <input
                  type="text"
                  matInput
                  maxlength="255"
                  autocomplete="off"
                  formControlName="county"
                />
              </mat-form-field>
            </div>
            <div class="form-field">
              <p class="fw-bold">Country</p>
                <ng-select
                  class="w-230"
                  [disableOptionCentering]="true"
                  formControlName="country"
                  panelClass="mat-select-position"
                >
                <ng-option *ngFor="let country of countryList" [value]="country.id">{{ country.description }}</ng-option>
              </ng-select>
            </div>
          </div>

          <div class="d-flex gap-20">
            <div class="form-field">
              <p class="fw-bold">Accounting Body</p>
                <div class="d-flex gap-20">
                  <ng-select
                  class="w-230"
                  [disableOptionCentering]="true"
                  panelClass="mat-select-position"
                  formControlName="selectedAccountingBody"
                  (change)="onAccountingBodyChange($event)"
                  >
                      <ng-option value="0">Other/None</ng-option>
                      <ng-option *ngFor="let item of accountingBodies" [value]="item">{{ item }}</ng-option>
                  </ng-select>
                  <mat-form-field appearance="fill" class="w-230">
                      <input
                      type="text"
                      matInput
                      maxlength="255"
                      autocomplete="off"
                      formControlName="accountingbody"
                      />
                  </mat-form-field>
                </div>
            </div>
          </div>
        </div>
  
      </form>
    </mat-dialog-content>
    <div class="d-flex pb-5 pt-10 hr-top pt-1 mt-5">
      <button
        class="action-button primary-button mr-1"
        type="button"
        mat-button
        disableRipple
        (click)="saveContactDetails()"
      >
        Save
      </button>
      <button
        class="action-button secondary-button"
        mat-dialog-close
        disableRipple
        type="button"
        mat-button
        disableRipple
      >
        Cancel
      </button>
    </div>
  </div>
  
  <app-custom-notifications></app-custom-notifications>
  